const variables = {
  font: {
    fontFamilyHead: 'Montserrat, Helvetica, Arial, sans-serif',
    fontFamilyButton: 'Montserrat, Helvetica, Arial, sans-serif',
    fontFamily: 'Raleway, Helvetica, Arial, sans-serif',
  },
};

export default variables;
